export default {
  // App Info
  get APP_NAME(): string {
    return 'Aizu'
  },
  get MAIL_ADDRESS_SUPP(): string {
    return 'aizu.supp@gmail.com'
  },
  get SUPPORT_TIME(): string {
    return '10:00〜18:00'
  },
  get CREDIX_TEL1(): string {
    return '0570-07-3210'
  },
  get CREDIX_TEL2(): string {
    return '03-6832-1339'
  },
  get CREDIX_MAIL_ADDRESS(): string {
    return 'creditinfo@credix-web.co.jp'
  },
  get APP_DATA_DIR(): string {
    return '.aizuchat'
  },
  get MAIN_COLOR(): string {
    return '#c95040'
  },

  get SNACKBAR_DURATION(): number {
    return 3000
  },
  get INIT_MSEC(): number {
    return 3000
  },

  // feature flags
  get FLAG_EDGE_SWIPE(): boolean {
    return true
  },
  get FLAG_NOZOKILIVE(): boolean {
    return false
  },
  get FLAG_TIMELINE(): boolean {
    return true
  },

  // Server
  get URL_SCHEME(): string {
    return 'aizuchat://'
  },
  get SERVER_URL(): string {
    return 'https://aizuchat.com'
  },
  get D_SERVER_URL(): string {
    return 'https://d.aizuchat.com'
  },
  get NOIMG_MAN_URL(): string {
    return this.D_SERVER_URL + '/img/noimgm_s.jpg'
  },
  get NOIMG_WOMAN_URL(): string {
    return this.D_SERVER_URL + '/img/noimgw_s.jpg'
  },
  get MOBILE_URL(): string {
    return this.SERVER_URL + '/mobile'
  },
  get FRONT_URL(): string {
    return this.SERVER_URL + '/front/ap'
  },
  get WEB_URL(): string {
    return this.SERVER_URL + '/web/web_index.html#'
  },
  get PAYMENT_URL(): string {
    return this.SERVER_URL + '/web/web_index.html#/payment'
  },

  // Push Notification
  get NOTIFICATION_CHANNEL_ID(): string {
    return 'NotificationChannel'
  },

  // Sentry
  get SENTRY_DSN(): string {
    return 'https://efce84df6fa34f42af8d6381b0c876b1@sentry.io/300898'
  },

  // Adjust
  get ADJUST_API_TOKEN(): string {
    return '1hkdklxy9p1c'
  },
  get ADJUST_EVENT_REGIST(): string {
    return 'c0konl'
  },
  get ADJUST_EVENT_PAYMENT(): string {
    return 'aysz1g'
  },

  // Analytics
  get GOOGLE_ANALYTICS_TRAKING_ID(): string {
    return 'UA-117089371-4'
  },

  // Messages
  get MSG_REJECT_GOOGLEPLAYSTORE(): string {
    return [
      'アプリがGooglePlayStoreで非公開となっております。',
      '大変お手数ですが、専用ページより最新バージョンをダウンロードしてください。'
    ].join('')
  },
  get MSG_WEBVIEW_VERSION(): string {
    return [
      '【注意】WebViewアプリのバージョンが古い恐れがあります。\n',
      'GooglePlayストアで「AndroidシステムのWebView」を検索してアップデートをお試しください。\n',
      '※古いバージョンだと動作が遅くなったり不具合が発生する場合があります。'
    ].join('')
  },

  // Encript
  get SECURE_PASSWORD(): string {
    return 'いつものパスワード'
  },
  get SECURE_KEY(): string {
    return '9933df88325f9141f622851831c46f21'
  },
  get SECURE_IV(): string {
    return '645bf6f0f3209790'
  }
}
